import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { FootprintsIcon, CookingPotIcon, SofaIcon, RotateCcwIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="w-full px-6 py-10 md:py-14" data-id="element-299">
      <div className="max-w-2xl mx-auto" data-id="element-300">
        <AnimatedSection data-id="element-301">
          <div className="w-12 h-px bg-sand mx-auto mb-8" data-id="element-302" />
        </AnimatedSection>

        <AnimatedSection data-id="element-303">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-3" data-id="element-304">
            ¿Qué cambia en 48 horas?
          </h2>
          <p className="text-warm-gray text-base md:text-lg leading-relaxed mb-6" data-id="element-305">
            No te prometo una casa de Pinterest.
            <br data-id="element-306" />
            Te prometo algo más importante:
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-307">
          <div className="space-y-4 mb-6" data-id="element-308">
            <div className="flex items-start gap-4" data-id="element-309">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-310">
                <FootprintsIcon className="w-5 h-5 text-teal" data-id="element-311" />
              </div>
              <p className="text-charcoal text-base md:text-lg leading-relaxed" data-id="element-312">
                Que puedas{' '}
                <strong className="font-medium" data-id="element-313">
                  caminar sin esquivar cosas
                </strong>
                .
              </p>
            </div>

            <div className="flex items-start gap-4" data-id="element-314">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-315">
                <CookingPotIcon className="w-5 h-5 text-teal" data-id="element-316" />
              </div>
              <p className="text-charcoal text-base md:text-lg leading-relaxed" data-id="element-317">
                Que tu cocina{' '}
                <strong className="font-medium" data-id="element-318">
                  deje de sentirse como una amenaza
                </strong>
                .
              </p>
            </div>

            <div className="flex items-start gap-4" data-id="element-319">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-320">
                <SofaIcon className="w-5 h-5 text-teal" data-id="element-321" />
              </div>
              <p className="text-charcoal text-base md:text-lg leading-relaxed" data-id="element-322">
                Que tengas una zona donde{' '}
                <strong className="font-medium" data-id="element-323">descansar sin culpa</strong>.
              </p>
            </div>

            <div className="flex items-start gap-4" data-id="element-324">
              <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-325">
                <RotateCcwIcon className="w-5 h-5 text-teal" data-id="element-326" />
              </div>
              <p className="text-charcoal text-base md:text-lg leading-relaxed" data-id="element-327">
                Que tengas un{' '}
                <strong className="font-medium" data-id="element-328">botón de reinicio</strong> para
                cuando recaigas.
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}